import type { ComboboxOptionsType } from '../types/combobox-root.types';
import { getFilteredOptionsCount } from './get-filtered-options-count';

export const COMBOBOX_LOADING_INSTRUCTIONS =
  'Options are loading. Wait for results to appear before making a selection.';
export const COMBOBOX_EMPTY_INSTRUCTIONS = 'No options are currently available.';
export const COMBOBOX_MULTI_SELECT_INSTRUCTIONS =
  'Type to filter options, then use up and down arrow keys to review results. Press Enter to add the highlighted option. Continue typing and pressing Enter to add multiple selections.';
export const COMBOBOX_SINGLE_SELECT_INSTRUCTIONS =
  'Type to filter options, then use up and down arrow keys to review results and press Enter to select.';
export const COMBOBOX_MULTI_SELECT_NAVIGATION_INSTRUCTIONS =
  'Use up and down arrow keys to review results. Press Enter to add the highlighted option. Continue pressing Enter to add multiple selections.';
export const COMBOBOX_SINGLE_SELECT_NAVIGATION_INSTRUCTIONS =
  'Use up and down arrow keys to review results and press Enter to select.';

export const getComboboxInputInstructions = ({
  editable = true,
  filteredOptions,
  isMultiSelect,
  loading,
}: {
  editable?: boolean;
  filteredOptions: ComboboxOptionsType;
  isMultiSelect: boolean;
  loading?: boolean;
}): string => {
  if (loading) {
    return COMBOBOX_LOADING_INSTRUCTIONS;
  }

  if (getFilteredOptionsCount(filteredOptions) === 0) {
    return COMBOBOX_EMPTY_INSTRUCTIONS;
  }

  if (isMultiSelect) {
    return editable
      ? COMBOBOX_MULTI_SELECT_INSTRUCTIONS
      : COMBOBOX_MULTI_SELECT_NAVIGATION_INSTRUCTIONS;
  }

  return editable
    ? COMBOBOX_SINGLE_SELECT_INSTRUCTIONS
    : COMBOBOX_SINGLE_SELECT_NAVIGATION_INSTRUCTIONS;
};
